import Vue from 'vue'
import App from './App.vue'
// 导入CSS样式文件
import './assets/css/style.scss'
import './assets/css/media.css'
// 导入ajax模块
import './ajax/index.js'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')